import React, {Component, createRef} from 'react';
import Style from "./FJHorizontalScrollerIncludeArrowButton.module.less";
import classNames from 'classnames';

class FJHorizontalScrollerIncludeArrowButton extends Component{
    constructor(props) {
        super(props);
        this.state = {
            left: "hide",
            right: "show",
            moveDistance: props.moveDistance ? props.moveDistance : 375
        }

        this._content = createRef();
        this._scroller = createRef();
    }

    componentDidMount() {

    }

    showAll = () => {
        this.setState({left: "show", right: "show"});
    }
    hideAll = () => {
        this.setState({left: "hide", right: "hide"});
    }
    hideLeft = () => {
        this.setState({left: "hide"});
    }
    showLeft = () => {
        this.setState({left: "show"});
    }
    hideRight = () => {
        this.setState({right: "hide"});
    }
    showRight = () => {
        this.setState({right: "show"});
    }
    leftClick = () => {
        this.showRight();
        if (this.props.leftClick) {
            if (this.props.leftClick(this.props.category, this.state.moveDistance)) {
                this.hideLeft();
            };
        }
    }
    rightClick = () => {
        this.showLeft();
        if (this.props.rightClick) {
            if (this.props.rightClick(this.props.category, this.state.moveDistance)) {
                this.hideRight();
            }
        }
    }

    render() {
        let {scrollerStyle, containerStyle, hasShadow, length, btnClassName} = this.props;
        return (
            <div ref={this._content} className={Style.content} style={containerStyle}>
                <div ref={this._scroller} className={Style.item_box + " u-no-scrollerbar"}
                     style={scrollerStyle}>
                    {this.props.children}
                </div>
                {this.state.left === 'show' && length > 3 && hasShadow ? <div className={Style.left_shadow}/> : null}
                {this.state.right === 'show' && length > 3 && hasShadow  ? <div className={Style.right_shadow}/> : null}
                {this.state.left === 'show' && length > 3 ? <LeftArrow hasShadow={hasShadow} onClick={this.leftClick} btnClassName={btnClassName}/> : null}
                {this.state.right === 'show' && length > 3 ? <RightArrow hasShadow={hasShadow} onClick={this.rightClick} btnClassName={btnClassName}/> : null}
            </div>
        );
    }

}

export default FJHorizontalScrollerIncludeArrowButton;

class LeftArrow extends Component {
    render() {
        let cn = Style.arrow_box + " " + Style.left;
        return (
            <div className={cn}>
                <div className={classNames(Style.arrow_button, this.props.btnClassName)} onClick={this.props.onClick}>
                    <svg className={Style.icon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="8px" height="12px" viewBox="0 0 8 12">
                        <g transform="translate(-596.000000, -349.000000)">
                            <path id="路径" fill="#1A1B1C" d="M601.773,350.365c0.465,0.479,0.465,1.24,0,1.719l-2.833,2.922l2.833,2.922
    c0.465,0.479,0.465,1.24,0,1.719c-0.445,0.461-1.182,0.475-1.641,0.025c-0.01-0.008-0.02-0.018-0.025-0.025l-3.825-3.941
    c-0.376-0.388-0.376-1.005,0-1.395l3.825-3.944c0.445-0.46,1.182-0.472,1.643-0.025
    C601.758,350.348,601.766,350.357,601.773,350.365z"/>
                        </g>
                    </svg>
                </div>
            </div>
        );
    }
}

class RightArrow extends Component {
    render() {
        let cn = Style.arrow_box + " " + Style.right;
        return (
            <div className={cn}>
                <div className={classNames(Style.arrow_button, this.props.btnClassName)} onClick={this.props.onClick}>
                    <svg className={Style.icon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="8px" height="12px" viewBox="0 0 8 12" >
                        <g transform="translate(-596.000000, -349.000000)">
                            <path id="路径" fill="#1A1B1C" d="M601.773,350.365c0.465,0.479,0.465,1.24,0,1.719l-2.833,2.922l2.833,2.922
    c0.465,0.479,0.465,1.24,0,1.719c-0.445,0.461-1.182,0.475-1.641,0.025c-0.01-0.008-0.02-0.018-0.025-0.025l-3.825-3.941
    c-0.376-0.388-0.376-1.005,0-1.395l3.825-3.944c0.445-0.46,1.182-0.472,1.643-0.025
    C601.758,350.348,601.766,350.357,601.773,350.365z"/>
                        </g>
                    </svg>
                </div>
            </div>
        );
    }
}
